// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"436783cd","270":"3c0b59c5","295":"6f0b889f","529":"9711d5dc","739":"e1181ee8"}[chunkId] + ".chunk.css";
};